export const requireEnv = (value: string | undefined, name: string): string => {
  if (!value) throw new Error(`${name} is not defined`);
  return value;
};

export function isDevEnvironment(): boolean {
  if (process.env.NODE_ENV === "development") return true;
  if (typeof window === "undefined") return false;
  const { hostname } = window.location;
  return hostname === "localhost" || hostname.endsWith("staging.stickergiant.com");
}
